import { PARSED_ENV } from "@/constants/common";
import { mediaHandlers } from "@/pages/Private/mocks/media.handlers";
import { authHandlers } from "@/pages/Public/mocks/auth.handlers";

/**
 * The worker starts for everyone in development, so media fixtures are opt-in: without
 * VITE_MOCK_MEDIA=true they would shadow the real API for anyone working against a live
 * backend.
 */
export const handlers = [
	...authHandlers,
	...(PARSED_ENV.VITE_MOCK_MEDIA === "true" ? mediaHandlers : []),
];
